const initialState = {
  datos: {},
  count: {},
  loading: true,
  error: null,
  status: null,
  datosFilter: {},
  loadingFilter: true,
  statusFilter: null,
  datosModal: {},
  loadingModal: true,
  statusModal: null,
  datosModalImg: {},
  loadingModalImg: true,
  statusModalImg: null,
  loadingTable: false,
  filters: {
    date: {
      fechaStartFinal: null,
      fechaEndFinal: null
    },
    tags: [],
    main: null
  },
  loadingFile: false,
  statusFile: null,
  datosFile: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/summary_inspections/initialState.js